import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";

import { UserRole } from "../../shared/data-types/roles.enum";
import { AuthStore } from "../../shared/store/auth.store";

export const hasRoleGuard = (allowRoles: UserRole[]): CanActivateFn => {
  return () => {
    const authStore = inject(AuthStore);
    const currentUser = authStore.currentUser();
    if (!currentUser) {
      return false;
    }
    return allowRoles.some((role) => role === currentUser?.role);
  };
};

